import { useActiveRoles, hasRole } from "../utils/permissionsUtils";
import { RoleEnum } from "../types/RoleEnum";
import { LIBRARY_WRITE_ROLES, PUBLISHER_WRITE_ROLES } from "../types/roleSets";
export var usePermissions = function () {
    var activeRoles = useActiveRoles();
    var checkRoles = function () {
        var roles = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            roles[_i] = arguments[_i];
        }
        return hasRole(activeRoles, RoleEnum.SUPERUSER) ||
            roles.some(function (role) { return hasRole(activeRoles, role); });
    };
    return {
        canCreateLibraryItem: checkRoles.apply(void 0, LIBRARY_WRITE_ROLES),
        canEditLibraryItem: checkRoles.apply(void 0, LIBRARY_WRITE_ROLES),
        canEditPublisherItem: checkRoles.apply(void 0, PUBLISHER_WRITE_ROLES),
        canVerifyTitleItem: checkRoles(RoleEnum.LIBRARIAN_LEGAL_DEPOSITS_MONOGRAPHS, RoleEnum.LIBRARIAN_LEGAL_DEPOSITS_PERIODICALS),
        canMergeProvisionalTitle: checkRoles(RoleEnum.ADMIN_LEGAL_DEPOSITS, RoleEnum.LIBRARIAN_LEGAL_DEPOSITS_MONOGRAPHS, RoleEnum.LIBRARIAN_LEGAL_DEPOSITS_PERIODICALS),
        canMergeTitles: checkRoles(RoleEnum.ADMIN_LEGAL_DEPOSITS, RoleEnum.LIBRARIAN_LEGAL_DEPOSITS_MONOGRAPHS, RoleEnum.LIBRARIAN_LEGAL_DEPOSITS_PERIODICALS),
        canLinkSpecialIssues: checkRoles(RoleEnum.ADMIN_LEGAL_DEPOSITS, RoleEnum.LIBRARIAN_LEGAL_DEPOSITS_MONOGRAPHS, RoleEnum.LIBRARIAN_LEGAL_DEPOSITS_PERIODICALS),
        canForceDeleteProvisionalTitle: checkRoles(RoleEnum.ADMIN_LEGAL_DEPOSITS),
        isSuperUser: hasRole(activeRoles, RoleEnum.SUPERUSER),
        isLoggedUser: hasRole(activeRoles, RoleEnum.LOGGED_USER),
        isSystem: hasRole(activeRoles, RoleEnum.SYSTEM),
        isAdminLegalDeposits: hasRole(activeRoles, RoleEnum.ADMIN_LEGAL_DEPOSITS),
        hasRole: function (role) {
            return checkRoles(role);
        },
        hasAnyRole: function (roles) {
            return checkRoles.apply(void 0, roles);
        },
    };
};
